var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C71F66",
    fillRule: "evenodd",
    d: "M4.148 17.481h8.889c.771 0 1.403.588 1.475 1.34l.007.142v8.889c0 .77-.587 1.403-1.34 1.475l-.142.006H4.148a1.481 1.481 0 0 1-1.475-1.339l-.006-.142v-8.889c0-.77.586-1.403 1.338-1.475l.143-.007h8.889zm23.704 0c.82 0 1.481.664 1.481 1.482v8.889c0 .818-.662 1.481-1.481 1.481h-8.889c-.82 0-1.482-.663-1.482-1.481v-8.889c0-.818.663-1.482 1.482-1.482zm-16.296 2.963H5.63v5.926h5.926v-5.926zm14.814 0h-5.926v5.926h5.926v-5.926zM13.037 2.667c.771 0 1.403.588 1.475 1.339l.007.142v8.889c0 .77-.587 1.403-1.34 1.475l-.142.007H4.148a1.481 1.481 0 0 1-1.475-1.34l-.006-.142V4.148c0-.77.586-1.403 1.338-1.475l.143-.006h8.889zm14.815 0c.77 0 1.403.588 1.475 1.339l.006.142v8.889c0 .77-.586 1.403-1.338 1.475l-.143.007h-8.889a1.481 1.481 0 0 1-1.475-1.34l-.007-.142V4.148c0-.77.587-1.403 1.34-1.475l.142-.006h8.889zM11.556 5.63H5.63v5.926h5.926V5.63zm14.814 0h-5.926v5.926h5.926V5.63z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllServices);
export default __webpack_public_path__ + "static/media/all-services.3e2efffd847614f22c94964540ee3711.svg";
export { ForwardRef as ReactComponent };